import * as React from "react";

const CrossSvg = (props) => (
    <svg
        className="HelloBar_closeIcon__kkOPe"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 27"
        xmlSpace="preserve"
        {...props}
        style={{ cursor: "pointer" }}
    >
        <title>{"Close"}</title>
        <path className="st0" d="m2.6 2.6 21.8 21.8m0-21.8L2.6 24.4" />
    </svg>
);

export default CrossSvg;
